import React, { useState } from "react";
import emailjs from "@emailjs/browser";


import Breadcrumb from "../components/breadcrumb/Breadcrumb";





const Contact = () => {

  const [formDataEmail, setFormDataEmail] = useState({
  email: "",
}
  );
  const [formDataName, setFormDataName] = useState(
    {
  name: "",
}
  );
 const [formDataCourse, setFormDataCourse] = useState({
  course: "Matematika - Ekonomski",
});
  const [formDataMessage, setFormDataMessage] = useState(
    {
  message: "",
}
  );
  const [formDataPhone, setFormDataPhone] = useState(
    {
  phone: "",
}
  );
  const [loading, setLoading] = useState(false);

const handleChangeEmail = (e) => {
    setFormDataEmail({
      ...formDataEmail,
      [e.target.name]: e.target.value,
    });
  };
const handleChangeMessage = (e) => {
    setFormDataMessage({
      ...formDataMessage,
      [e.target.name]: e.target.value,
    });
  };
const handleChangeCourse = (e) => {
  setFormDataCourse({
    ...formDataCourse,
    [e.target.name]: e.target.value,
  });
};

const handleChangePhone = (e) => {
    setFormDataPhone({
      ...formDataPhone,
      [e.target.name]: e.target.value,
    });
  };
const handleChangeName = (e) => {
    setFormDataName({
      ...formDataName,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formDataEmail.email !== '' && formDataName.name !== '' && formDataCourse.course !== '' && formDataPhone.phone !== '') {
      const templateParams = {
        email: formDataEmail.email,
        name: formDataName.name,
        course: formDataCourse.course,
        message: formDataMessage.message || "No message",
        phone: formDataPhone.phone,
        time: new Date().toLocaleString("sr-RS"),
      };

      setLoading(true);
      document.body.style.cursor = "wait";

      emailjs.send(
        "service_ymukqb7",     // Your EmailJS service ID
        "template_frwu6hi",    // Your EmailJS template ID
        templateParams,   // Object with template variables
        "ZJWDy0LZKVyetHSJT"   // Your EmailJS public key
      )
        .then(() => {
          alert("Uspešna prijava! Kontaktiraćemo Vas u najkraćem roku.");
        })
        .catch((err) => {
          console.error("EmailJS error:", err);
        })
        .finally(() => {
          setLoading(false);
          document.body.style.cursor = "";
        });

    } else {
      alert("Morate uneti sve potrebne podatke")
    }
  };

  return (
    <>
      <Breadcrumb current='Kontakt' />
      <section className="contact">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="contact-items">
                <h2 className="mb-4 fw-bold">Kontakt</h2>
                <div className="contact-item d-flex mb-2 ">
                  <div className="item-icon me-4 fs-4 theme-bg p-2 rounded-circle">
                    <i className="fas fa-map-marked-alt"></i>
                  </div>
                  <div className="item-text">
                    <h5>Adresa</h5>
                    <p>Republička 2A, Čukarica</p>
                  </div>
                </div>
                <div className="contact-item d-flex mb-2 ">
                  <div className="item-icon me-4 fs-4 theme-bg p-2 rounded-circle">
                    <i className="fas fa-phone"></i>
                  </div>
                  <div className="item-text">
                    <h5>Broj telefona</h5>
                    <p>0641230910</p>
                  </div>
                </div>
                <div className="contact-item d-flex mb-2 ">
                  <div className="item-icon me-4 fs-4 theme-bg p-2 rounded-circle">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="item-text">
                    <h5>Email</h5>
                    <p>smartbasic@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="contact-form box">
                <h2 className="text-center fs-4 fw-bold mb-5">Prijavi se na kurs</h2>
                <form>
                  <div className="form-group mb-3">
                    <input
  type="text"
  name="name"
  placeholder="Ime i Prezime"
  className="form-control"
  value={formDataName.name}
                      onChange={handleChangeName}
                      required
/>
                  </div>
                  <div className="form-group mb-3">
                    <input
  type="email"
  name="email"
  placeholder="Email"
  className="form-control"
  value={formDataEmail.email}
                      onChange={handleChangeEmail}
                      required
/>

                  </div>
                  <div className="form-group mb-3">
                    <input
  type="tel"
  name="phone"
  placeholder="Broj telefona"
  className="form-control"
  value={formDataPhone.phone}
                      onChange={handleChangePhone}
                      required
/>
                  </div>
                  <div className="form-group mb-3">
                    <textarea
                      
  name="message"
  placeholder="Poruka (Opciono)"
  className="form-control"
  value={formDataMessage.message}
  onChange={handleChangeMessage}
                    ></textarea>
                  </div>
                  <div className="form-group mb-3">
                    <select
                    
  name="course"
  placeholder="Kurs"
  className="form-control"
  value={formDataCourse.course}
                      onChange={handleChangeCourse}
                      required>
  <option value="Matematika - Ekonomski">Matematika - Ekonomski</option>
  <option value="Osnovi Ekonomije - Ekonomski">Osnovi Ekonomije - Ekonomski </option>
  <option value="Statistika - Ekonomski">Statistika - Ekonomski</option>
  <option value="Mikroekonomija - Ekonomski ">Mikroekonomija - Ekonomski </option>
  <option value="Osnovi operacionih istraživanja - Ekonomski">Osnovi operacionih istraživanja - Ekonomski</option>
  <option value="Upravljačko računovodstvo - Ekonomski">Upravljačko računovodstvo - Ekonomski</option>
  <option value="Linearna Algebra - Ekonomski">Linearna Algebra - Ekonomski</option>
  <option value="Teorija Verovatnoća - Ekonomski">Teorija Verovatnoća - Ekonomski</option>
  <option value="Diskretna Matematika - Ekonomski">Diskretna Matematika - Ekonomski</option>
  <option value="Finansijska i aktuarska matematika - Ekonomski">Finansijska i aktuarska matematika - Ekonomski</option>
  <option value="Teorija Odlučivanja - Ekonomski">Teorija Odlučivanja - Ekonomski</option>
  <option value="Teorijska statistika - Ekonomski">Teorijska statistika - Ekonomski</option>
  <option value="Ekonomska Statistika - Ekonomski">Ekonomska Statistika - Ekonomski</option>
  <option value="Računovodstvo Troškova - Ekonomski">Računovodstvo Troškova - Ekonomski</option>
  <option value="Matematika 1 - FON">Matematika 1 - FON</option>
  <option value="Matematika 2 - FON">Matematika 2 - FON</option>
  <option value="Matematika 3 - FON">Matematika 3 - FON</option>
  <option value="Verovatnoća - FON">Verovatnoća - FON</option>
  <option value="Statistika - FON">Statistika - FON</option>
  <option value="Matematika 1 - Saobraćajni">Matematika 1 - Saobraćajni</option>
  <option value="Prijemni - Ekonomski">Prijemni - Ekonomski</option>
  <option value="Prijemni - FON">Prijemni - FON</option>
  <option value="Finansijska matematika za Master - Ekonomski">Finansijska matematika za Master - Ekonomski</option>
</select>
                  </div>
                  <button type="submit" className="theme-btn w-100"
                  onClick={handleSubmit}
                  disabled={loading}>
                    {loading ? "Slanje..." : "Pošalji prijavu"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
